import React, { Component } from "react";
import ReactCrop, { makeAspectCrop } from 'react-image-crop';
import { cropImg, loadImgFromLocalFile, resizeImage }  from '../lib/imageFunctions'
import 'react-image-crop/dist/ReactCrop.css';

export class ManageImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileName:undefined,
      crop:undefined,
      pixelCrop:undefined,
      originalImageData:undefined
    }
    this.handleCrop = this.handleCrop.bind(this);
  }

  async handleImageChange(e) {
    e.preventDefault();
    let file = e.target.files[0];
    var originalImageData = await loadImgFromLocalFile(file);
    var imageData = await resizeImage(originalImageData, 960, 540);
    this.setState({
      fileName: file,
      originalImageData: imageData,
    });
  }

  async handleCrop () {
    const state = this.state;
    var croppedImg = await cropImg(state.originalImageData, state.pixelCrop);
    croppedImg = await resizeImage(croppedImg, 480, 270);
    this.setState({
      originalImageData:undefined
    })
    this.props.onChange(croppedImg);
  }

  onImageLoaded = (image) => {
    this.setState({
      crop: makeAspectCrop({
        x: 0,
        y: 0,
        aspect: 16 / 9,
        width: 50,  //width is a percentage of image
      }, image.naturalWidth / image.naturalHeight),
      image,
    });
  }

  onCropComplete = (crop, pixelCrop) => {
    this.setState({pixelCrop: pixelCrop});
  }

  onCropChange = (crop) => {
    this.setState({crop: crop});
    //console.log(crop);
  }

  render() {
    return (
      <div>
        <input
         name="myFile"
         type="file"
         onChange={(e)=>this.handleImageChange(e)}
        />
        <div>
          <Image
            {...this}
          />
        </div>
      </div>
    );
  }
}

function Image(props) {
  var imageSrc = undefined;
  if (props.state.originalImageData) {
    /*Uploaded Image EDIT*/
    imageSrc = props.state.originalImageData;
    return (
      <div>
        <div>
          <button onClick={props.handleCrop}>Crop</button>
        </div>
        <ReactCrop
          style={{maxWidth:"800px"}}
          {...props.state}
          src={imageSrc}
          onImageLoaded={props.onImageLoaded}
          onComplete={props.onCropComplete}
          onChange={props.onCropChange}
        />
      </div>
    );
  } else if (props.props.workingImageData) {
    /*Image has been uploaded and had been cropped READONLY*/
    console.log("Image2")
    imageSrc = props.props.workingImageData;
    return (
      <img
        style={{maxWidth:"800px"}}
        src={imageSrc}
        alt="remove warning"
      />
    );
  } else if (props.props.src) {
    /*Image is sourced from the server READONLY */
    imageSrc = props.props.src;
    return (
      <img
        style={{maxWidth:"800px"}}
        src={imageSrc}
        alt="remove warning"
      />
    );
  } else {
    /*NO IMAGE HAND BEEN UPLOADED */
    return (
      <div>
        "No Image"
      </div>
    );
  }
}

/*
https://github.com/DominicTobias/react-image-crop


<img
  src={this.state.src}
/>
*/



// WEBPACK FOOTER //
// ./src/components/ManageImage.js